"use client";

export default function VersionTag() {
  const version = "1.0.10";

  return (
    <div className="fixed bottom-4 left-4 z-50 bg-white border text-gray-900/80 text-xs px-3 py-1.5 rounded-full backdrop-blur-sm shadow-md">
      v{version}
    </div>
  );
}
